
import { useParams } from "react-router-dom";
import { DevotionalContent } from "@/components/DevotionalContent";
import { getDevotionalForDate } from "@/data/devotionals";
import { useAuth } from "@/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { parseISO } from "date-fns";

const DevotionalPage = () => {
  const { date } = useParams();
  const { user } = useAuth();

  const { data: devotionalData, isLoading } = useQuery({
    queryKey: ["devotional", date],
    queryFn: () => date ? getDevotionalForDate(parseISO(date)) : Promise.resolve(undefined),
    enabled: !!date,
  });

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white flex items-center justify-center">
        <p className="text-xl text-sage-600">Loading devotional...</p>
      </div>
    );
  }

  if (!devotionalData) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white flex items-center justify-center">
        <p className="text-xl text-sage-800">Devotional not found.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white">
      <main className="max-w-4xl mx-auto px-4 py-8">
        <DevotionalContent {...devotionalData} userId={user?.id} />
      </main>
    </div>
  );
};

export default DevotionalPage;
